'use client'

import React, { forwardRef } from 'react'
import './Button.css'

export type ButtonVariant = 'default' | 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'success' | 'grey' | 'link' | 'link-danger' | 'link-success'
export type ButtonSize = 'xs' | 'sm' | 'md' | 'lg'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  icon?: string
  iconPosition?: 'left' | 'right'
  loading?: boolean
  fullWidth?: boolean
  children?: React.ReactNode
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  variant = 'default',
  size = 'md',
  icon,
  iconPosition = 'left',
  loading = false,
  fullWidth = false,
  disabled,
  className = '',
  children,
  ...props
}, ref) => {
  const classes = [
    'ui-btn',
    `ui-btn--${variant}`,
    `ui-btn--${size}`,
    fullWidth && 'ui-btn--full',
    loading && 'ui-btn--loading',
    !children && icon && 'ui-btn--icon-only',
    className
  ].filter(Boolean).join(' ')

  return (
    <button
      ref={ref}
      className={classes}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <i className="fa-solid fa-spinner fa-spin ui-btn__spinner" />
      )}
      {!loading && icon && iconPosition === 'left' && (
        <i className={`${icon} ui-btn__icon`} />
      )}
      {children && <span className="ui-btn__text">{children}</span>}
      {!loading && icon && iconPosition === 'right' && (
        <i className={`${icon} ui-btn__icon`} />
      )}
    </button>
  )
})

Button.displayName = 'Button'

export default Button
